import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { CASHIER_ROUTE, LandingRouteService } from 'src/app/services/auth/landing-route.service';

/**
 * Dipasang di layout dashboard penuh: akun kasir-saja yang membuka alamat dashboard (mis. lewat
 * bookmark) dibawa ke layar kasir, bukan ke halaman yang menolak mereka satu per satu.
 */
@Injectable({ providedIn: 'root' })
export class CashierOnlyRedirectGuard implements CanActivate {
  constructor(private landing: LandingRouteService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    return this.landing.isCashierOnly() ? this.router.parseUrl(CASHIER_ROUTE) : true;
  }
}
